import {Component, inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {AppScope} from '../../../services/app_scope.service';

@Component({
  selector: 'src-no-account',
  imports: [MatButtonModule],
  templateUrl: './no-account.component.html',
  styleUrl: './no-account.component.scss',
})
export class NoAccountComponent {
  private readonly appScope = inject(AppScope);

  signOut(): void {
    // AppScope.logout() triggers an immediate window.location redirect (Keycloak),
    // so any toast queued here would be torn down with the document before it can render.
    // The redirect itself is the user-visible feedback.
    this.appScope.logout();
  }
}
